import React, { Component } from 'react'
import { Query, Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import {
  Column,
  Title,
  Icon,
  Control,
  Input,
  NavbarItem,
  NavbarDropdown,
  Subtitle,
  NavbarDivider,
  NavbarLink,
  Columns,
  Button
} from 'bloomer'
import { DragDropContext } from 'react-beautiful-dnd'
import { Link, Redirect } from 'react-router-dom'

import { HouseContext } from 'contexts'
import BaseLayout from 'containers/BaseLayout'
import styled from 'styled-components'

import Room from './Room'

import HeaderTitle from 'components/HeaderTitle'

import AddModuleModal from './modals/AddModuleModal'
import AddRoomModal from './modals/AddRoomModal'
import UpdateHouseModal from './modals/UpdateHouseModal'
import AddMemberModal from './modals/AddMemberModal'


const MODULE_FIELDS = gql`
  fragment moduleFields on ModuleType {
    id,
    name,
    isActive,
    identifier,
    moduleModel {
      id, name
    }
  }
`

const GET_HOUSE = gql`
  query ($houseId: UUID!) {
    house(houseId: $houseId) {
      id,
      name,
      description,
      rooms {
        id,
        name,
        modules {
          ...moduleFields
        }
      },
      owner {
        id
      }
    },
    me {
      id
    }
  }
  ${MODULE_FIELDS}
`

const UPDATE_ROOM_MODULE = gql`
  mutation ($roomId: UUID!, $moduleId: UUID!) {
    updateModule(roomId: $roomId, moduleId: $moduleId) {
      module {
        ...moduleFields
      }
    }
  }
  ${MODULE_FIELDS}
`

const SearchBar = styled.div`
  max-width: 50rem;
  margin: 0 auto 2rem;
`

const ADD_MODULE_MODAL = 'ADD_MODULE_MODAL'
const ADD_ROOM_MODAL = 'ADD_ROOM_MODAL'
const UPDATE_HOUSE_MODAL = 'UPDATE_HOUSE_MODAL'
const ADD_MEMBER_MODAL = 'ADD_MEMBER_MODAL'

export default class DashboardPage extends Component {
  state = {
    search: '',
    isHouseMenuActive: false,
    modalId: null,
  }

  constructor(props) {
    super(props)
    this.houseMenuRef = React.createRef()
  }

  search = (module) => {
    const { search } = this.state

    return (module.name.toLowerCase().indexOf(search) >= 0 || module.moduleModel.name.toLowerCase().indexOf(search) >= 0)
  }

  handleSearchChange = (evt) => {
    const search = evt.target.value.toLowerCase()
    this.setState(() => ({
      search
    }))
  }

  handleClickOutsideHouseMenu = (evt) => {
    const { isHouseMenuActive } = this.state
    if (isHouseMenuActive && this.houseMenuRef.current && !this.houseMenuRef.current.contains(evt.target)) {
      this.handleToggleHouseMenu()
    }
  }

  handleToggleHouseMenu = () => {
    this.setState(({isHouseMenuActive}) => ({
      isHouseMenuActive: !isHouseMenuActive
    }))
  }

  handleOpenModal = (modalId, evt) => {
    this.setState(() => ({
      modalId
    }))

    evt.preventDefault()
  }

  handleCloseModal = () => {
    this.setState(() => ({
      modalId: null
    }))
  }

  handleDragEnd = async (updateRoomModuleMutation, house, result) => {
    if (!result.destination) {
      return
    }

    const {
      draggableId: moduleId,
      destination: { droppableId: roomId },
      source: { droppableId: previousRoomId }
    } = result

    if (roomId === previousRoomId) {
      return
    }

    const room = house.rooms.find(r => r.id === previousRoomId)
    const module = room.modules.find(m => m.id === moduleId)

    try {
      await updateRoomModuleMutation({
        variables: {
          roomId, moduleId
        },
        optimisticResponse: {
          updateModule: {
            module: {
              ...module,
              __typename: "ModuleType"
            },
            __typename: "UpdateModule"
          }
        },
        update: (store, { data: {updateModule}}) => {
          const roomFragment = gql`
            fragment roomFields on RoomType {
              id, modules {
                ...moduleFields
              }
            }
            ${MODULE_FIELDS}
          `

          const previousRoom = store.readFragment({
            id: `RoomType:${previousRoomId}`,
            fragmentName: 'roomFields',
            fragment: roomFragment,
          })

          const room = store.readFragment({
            id: `RoomType:${roomId}`,
            fragmentName: 'roomFields',
            fragment: roomFragment,
          })

          previousRoom.modules = previousRoom.modules.filter(m => m.id !== moduleId)
          room.modules = [...room.modules, updateModule.module]

          store.writeFragment({
            id: `RoomType:${previousRoomId}`,
            fragment: roomFragment,
            fragmentName: 'roomFields',
            data: previousRoom
          })

          store.writeFragment({
            id: `RoomType:${roomId}`,
            fragment: roomFragment,
            fragmentName: 'roomFields',
            data: room
          })
        }
      })
    } catch (e) {
      // TODO: handle error
      console.error(e)
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideHouseMenu)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideHouseMenu)
  }

  renderHeaderTitle(house, me) {
    const { isHouseMenuActive } = this.state

    const isOwner = house.owner.id === me.id

    return (
      <NavbarItem hasDropdown isActive={isHouseMenuActive} onClick={this.handleToggleHouseMenu} render={(props) => <div {...props} ref={this.houseMenuRef}/>}>
        <HeaderTitle component={NavbarLink} style={{minWidth: '25rem', justifyContent: 'center', paddingRight: '1rem'}}>{house.name}</HeaderTitle>
        <NavbarDropdown style={{maxWidth: '12rem'}} isBoxed>
          <NavbarItem>
            <div style={{whiteSpace: 'normal', width: '100%'}}>
              {isOwner && (<Button isPulled="right" isSize="small" isColor="light" onClick={this.handleOpenModal.bind(this, UPDATE_HOUSE_MODAL)}>
                <Icon icon="pencil-alt" />
              </Button>)}
              <Title isSize={5} onClick={(evt) => evt.stopPropagation()} >{house.name}</Title>
              <Subtitle isSize={6} onClick={(evt) => evt.stopPropagation()} >{house.description}</Subtitle>
            </div>
          </NavbarItem>
          <NavbarDivider />
          {isOwner && (
            <React.Fragment>
              <NavbarItem href="#" onClick={this.handleOpenModal.bind(this, ADD_MEMBER_MODAL)}>Adicionar membro</NavbarItem>
              <NavbarDivider />
            </React.Fragment>
          )}
          <NavbarItem href="#" onClick={this.handleOpenModal.bind(this, ADD_MODULE_MODAL)}>Adicionar módulo</NavbarItem>
          <NavbarItem href="#" onClick={this.handleOpenModal.bind(this, ADD_ROOM_MODAL)}>Adicionar cômodo</NavbarItem>
          <NavbarDivider />
          <NavbarItem render={(props) => <Link to="/switch" {...props} />}>Escolher casa</NavbarItem>
        </NavbarDropdown>
      </NavbarItem>
    )
  }

  renderModal(Modal, id, props) {
    const { modalId } = this.state

    if (modalId !== id) {
      return null
    }

    return <Modal isActive={modalId === id} handleClose={this.handleCloseModal} {...props} />
  }

  renderModals(house, refetch) {
    return (
      <React.Fragment>
        {this.renderModal(AddModuleModal, ADD_MODULE_MODAL, {rooms: house.rooms, refetch})}
        {this.renderModal(AddRoomModal, ADD_ROOM_MODAL, {houseId: house.id, refetch})}
        {this.renderModal(AddMemberModal, ADD_MEMBER_MODAL, {houseId: house.id, refetch})}
        {this.renderModal(UpdateHouseModal, UPDATE_HOUSE_MODAL, {house})}
      </React.Fragment>
    )
  }

  render() {
    const { search } = this.state

    return (
      <HouseContext.Consumer>
        {({houseId}) => {
          if (!houseId) {
            return <Redirect to="/switch" />
          }

          return (
            <Query query={GET_HOUSE} variables={{houseId: houseId}}>
              {({loading, error, data, refetch}) => (
                <BaseLayout title={this.renderHeaderTitle.bind(this, data.house, data.me)} loading={loading} error={error}>
                  <SearchBar>
                    <Control hasIcons="right">
                      <Input placeholder="Buscar" value={search} onChange={this.handleSearchChange} />
                      <Icon isAlign="right" icon="search"/>
                    </Control>
                  </SearchBar>

                  <Mutation mutation={UPDATE_ROOM_MODULE}>
                  {(updateRoomModule) => (
                    <DragDropContext onDragEnd={this.handleDragEnd.bind(this, updateRoomModule, data.house)}>
                      <Columns isMultiline>
                        {data.house.rooms.map(room => (
                          <Column key={room.id} isSize="1/2">
                            <Room room={room} refetch={refetch} search={this.search} />
                          </Column>
                        ))}
                      </Columns>
                    </DragDropContext>
                  )}
                  </Mutation>

                  {data.house && this.renderModals(data.house, refetch)}
                </BaseLayout>
              )}
            </Query>
          )
        }}
      </HouseContext.Consumer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/index.js